import { Container, styled } from '@mui/material'

export const StyledStatsContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  [theme.breakpoints.up('sm')]: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: theme.spacing(5.75),
  },
}))
